import { Button } from "react-bootstrap";
import styled from "styled-components";

const StyledBtn = styled(Button)`
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 110px;
    min-height: 48px;
    padding: 8px 18px 8px 18px;
    border-radius: 24px;
    box-shadow: none;
    &:disabled {
        cursor: not-allowed;
        opacity: 1;
    }
    > a {
        color: inherit;
        text-decoration: none;
    }
    svg {
        width: 17px !important;
        height: 17px !important;
    }
`;

const BtnPrimary = styled(StyledBtn)`
    color: #fff;
    background: #8a0538;
    border: 1px solid #8a0538;
    &:active,
    &:focus-visible,
    &:hover {
        color: #fff !important;
        background: #8a0538 !important;
        border: 1px solid #8a0538 !important;
        background-image: linear-gradient(rgb(0 0 0/10%) 0 0) !important;
    }
    &:disabled {
        color: #404040;
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
    }
`;

const BtnOutlinePrimary = styled(StyledBtn)`
    color: #8a0538;
    background: transparent;
    border: 1px solid #8a0538;
    &:active,
    &:focus-visible,
    &:hover {
        color: #8a0538 !important;
        background: transparent !important;
        border: 1px solid #8a0538 !important;
        svg {
            fill: #8a0538;
            margin-right: 5px;
        }
    }
    &:disabled {
        color: #787878;
        background: transparent;
        border: 1px solid #787878;
        svg {
            fill: #787878;
            margin-right: 5px;
        }
    }
    svg {
        fill: #8a0538;
        margin-right: 5px;
    }
`;

const DefaultButtonLink = styled(StyledBtn)`
    color: #8a0538;
    background: transparent;
    border: none;
    &:active,
    &:focus-visible,
    &:hover {
        color: #8a0538 !important;
        background: transparent !important;
        border: none !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
    &:disabled {
        background: #e4e4e4;
        color: #404040;
        border: none;
        > svg {
            fill: #787878;
        }
    }
    > svg {
        fill: #8a0538;
    }
`;

const BtnCustom = styled(StyledBtn)`
    color: #8a0538;
    background: #f0f2f2;
    border: 1px solid #8a0538;
    &:active,
    &:focus-visible,
    &:hover {
        color: #8a0538 !important;
        background: #f0f2f2 !important;
        border: 1px solid #8a0538 !important;
        background-image: linear-gradient(rgb(0 0 0/10%) 0 0) !important;
    }
    &:disabled {
        color: #404040;
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
    }
`;

const BtnTable = styled(Button)`
    font-size: 17px;
    min-width: inherit;
    min-height: inherit;
    padding: 0;
    border: none;
    box-shadow: none;
    text-decoration: none !important;
    vertical-align: center;
    justify-content: center;
    &:disabled {
        cursor: not-allowed;
        opacity: 1;
    }
    &.green-color {
        color: #327e38 !important;
    }
    &.red-color {
        color: #a10101 !important;
    }
    &.yellow-color {
        color: #a16000 !important;
    }
    &.space-left {
        margin-left: 18px;
    }
    &.btn-align {
        vertical-align: center;
        svg {
            vertical-align: baseline;
        }
    }
`;

const BtnLink = styled(StyledBtn)`
    min-width: inherit;
    min-height: inherit;
    padding: 0;
    border: none;
    box-shadow: none;
    text-decoration: none !important;
    vertical-align: center;
    justify-content: center;
    color: #8a0538;
    background: transparent !important;
    svg {
        fill: #8a0538;
    }
    &:hover {
        color: #8a0538 !important;
        background: transparent !important;
        border: none !important;
        svg {
            fill: #8a0538;
        }
    }
    &:disabled {
        background: transparent !important;
        color: #404040;
        border: none;
        svg {
            fill: #787878;
        }
    }
`;

export default {
    BtnPrimary,
    BtnOutlinePrimary,
    DefaultButtonLink,
    BtnTable,
    BtnLink,
    BtnCustom,
};
